module.exports = __webpack_public_path__ + "img/clock-six-thirty.de6883a9.svg";